import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import CameraPanelUI from '@/components/top/summary_panels/camera/CameraPanelUI.vue'
import { useInitDataStore } from '@/stores/initDataStore'
import { DefinitionInfoSummaryItemCamera } from '@/models/initData/DefinitionInfo'

type CameraPanelProps = {
  cell: DefinitionInfoSummaryItemCamera
}


export default /*#__PURE__*/_defineComponent({
  props: {
    cell: null
  },
  setup(__props: any) {

const props = __props as {
  cell: DefinitionInfoSummaryItemCamera
}



const initDataStore = useInitDataStore()
const params = computed(() => {
  const { title, path } = props.cell.args
  const noImagePath = initDataStore.initData.layoutInfo.camera.common.cameraNoimage

  return { title, path, noImagePath }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CameraPanelUI, _normalizeProps(_guardReactiveProps(_unref(params))), null, 16))
}
}

})